export const AUTO_LAYOUT_REDUCER_STATE_ID = 'autoLayout';

export const TAB_SET_SCREENS_WRAPPER = 'tabsetcontainer';
export const ARRAY_SCREENS_WRAPPER = 'arraycontainer';
export const CONTAINER_INDEX_SCREEN_ID_SUFFIX = '$index';
export const CONTEXT_PARAMS_DELIMITER = '#';
export const CONFLICT_HTTP_CODE = 409;

export const MULTI_LINE_BOX_ROWS_DEFAULT = 4;
